<script>
import { mapActions } from 'vuex';
import request from '@/services/request';
import Catalogue from '@/services/catalogue';


export default {
    props: {
        companies: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            catalogue: new Catalogue(),
            errors: {},

            bankAccounts: [],
            providers: [],

            form: {
                id: '',
                company_id: '',
                payable_type_id: '',
                bank_account_id: '',
                provider_id: '',
                payments_per_month: '',
                max_amount_per_payment: '',
                max_amount_per_month: '',
                active: 1,
            },
        };
    },

    methods: {
        calculateMaxAmountPerMonth() {
            const paymentsPerMonth = parseInt(this.form.payments_per_month) || 0;

            const maxAmountPerPayment =
                parseFloat(this.form.max_amount_per_payment) || 0;

            if (paymentsPerMonth <= 0 || maxAmountPerPayment <= 0) {
                this.form.max_amount_per_month = '';
                return;
            }

            this.form.max_amount_per_month =
                paymentsPerMonth * maxAmountPerPayment;
        },
        closedModal() {
            this.resetForm();
            this.$modal.hide('addBankingServicePaymentRule');
        },

        resetForm() {
            this.errors = {};

            this.bankAccounts = [];
            this.providers = [];

            this.form = {
                id: '',
                payable_type_id: '',
                bank_account_id: '',
                provider_id: '',
                payments_per_month: '',
                max_amount_per_payment: '',
                max_amount_per_month: ''
            };
        },

        onPayableTypeChange() {
            const type = parseInt(this.form.payable_type_id);

            if (type === 1) {
                this.form.provider_id = '';
            }

            if (type === 2) {
                this.form.bank_account_id = '';
            }
        },

        preparePayload() {
            const type = parseInt(this.form.payable_type_id);

            return {
                id: this.form.id,
                company_id: this.form.company_id,
                payable_type_id: type,

                bank_account_id: type === 1
                    ? this.form.bank_account_id
                    : null,

                provider_id: type === 2
                    ? this.form.provider_id
                    : null,

                payments_per_month: this.form.payments_per_month || null,
                max_amount_per_payment: this.form.max_amount_per_payment || null,
                max_amount_per_month: this.form.max_amount_per_month || null,
                active: this.form.active,
            };
        },

        async saveRule() {

            let form = this.preparePayload();

            let _endpoint = '/banking-service-payment-rules';

            if (form.id !== '') {
                form._method = 'PUT';
                _endpoint = `/banking-service-payment-rules/${form.id}`;
            }

            try {
                let { data } = await request.post(_endpoint, form);

                if (data) {
                    this.successNotification(data.message);
                    this.closedModal();
                    Event.$emit('event-reload-banking-service-payment-rule');
                }
            } catch (error) {
                this.errors = {};

                if (error.response) {
                    this.errors = await this.errorNotification(error);
                }
            }
        },

        formatBankAccountOption(account) {
            let name = account.name;
            if (account.bank) {
                name += ` / ${account.bank.name}`;
            }

            if (account.number) {
                name += ` - ${account.number}`;
            }

            return name;
        },

        ...mapActions({
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        }),
    },

    created() {
        Event.$on('event-show-banking-service-payment-rule', async (rule) => {
            this.resetForm();

            if (rule && rule.id) {
                this.form.id = rule.id;
                this.form.payable_type_id = rule.payable_type_id;
                this.form.bank_account_id = rule.bank_account_id || '';
                this.form.provider_id = rule.provider_id || '';
                this.form.payments_per_month = rule.payments_per_month || '';
                this.form.max_amount_per_payment = rule.max_amount_per_payment || '';
                this.form.max_amount_per_month = rule.max_amount_per_month || '';
                this.form.active = rule.active ? 1 : 0;
            }

            this.$modal.show('addBankingServicePaymentRule');
        });
    },
    mounted() {
        // this.catalogue.getBankAccountAll();
        // this.catalogue.get_users_profiles(2);

        this.catalogue.get_bank_accounts_rules(2);
        this.catalogue.get_providers_rules(2);
    },
    watch: {
        'form.payments_per_month': function () {
            this.calculateMaxAmountPerMonth();
        },

        'form.max_amount_per_payment': function () {
            this.calculateMaxAmountPerMonth();
        },
    },
};
</script>

<template>
    <modal v-bind:click-to-close="false" name="addBankingServicePaymentRule" :width="'80%'" :height="'auto'">
        <form @submit.prevent="saveRule" method="post">
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closedModal()">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">
                    Regla de pago de servicio bancario
                </h5>
            </div>

            <div class="modal-body">
                <div class="row">

                    <div class="col-md-6">
                        <label>Tipo de regla</label>
                        <select class="form-control" v-model="form.payable_type_id" @change="onPayableTypeChange">
                            <option value="">Selecciona tipo</option>
                            <option :value="1">Cuenta bancaria</option>
                            <option :value="2">Proveedor</option>
                        </select>

                        <div v-if="errors && errors.payable_type_id" class="text-danger">
                            {{ errors.payable_type_id[0] }}
                        </div>
                    </div>

                    <div v-if="parseInt(form.payable_type_id) === 1" class="col-md-6">
                        <label>Cuenta bancaria</label>
                        <select class="form-control" v-model="form.bank_account_id">
                            <option value="">Selecciona cuenta bancaria</option>

                            <option v-for="(account, index) in catalogue.bank_accounts_rules" :key="index"
                                :value="account.id">
                                {{ account.name }} - <span v-if="account.bank">{{ account.bank.name }} / </span> {{ account.number }}
                            </option>
                        </select>

                        <div v-if="errors && errors.bank_account_id" class="text-danger">
                            {{ errors.bank_account_id[0] }}
                        </div>
                    </div>



                    <div v-if="parseInt(form.payable_type_id) === 2" class="col-md-6">
                        <label>Proveedor</label>
                        <select class="form-control" v-model="form.provider_id">
                            <option value="">Selecciona proveedor</option>

                            <option v-for="(provider, index) in catalogue.providers_rules" :key="index"
                                :value="provider.id">
                                {{ provider.name }} {{ provider.last_name }}
                            </option>
                        </select>

                        <div v-if="errors && errors.provider_id" class="text-danger">
                            {{ errors.provider_id[0] }}
                        </div>
                    </div>
                </div>

                <div class="row">

                    <div class="col-md-4 mt-2">
                        <label>Pagos al mes</label>
                        <input type="number" min="1" class="form-control" v-model="form.payments_per_month"
                            placeholder="Ej. 3">

                        <div v-if="errors && errors.payments_per_month" class="text-danger">
                            {{ errors.payments_per_month[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Monto máximo por pago</label>
                        <money class="form-control" v-model="form.max_amount_per_payment"></money>

                        <div v-if="errors && errors.max_amount_per_payment" class="text-danger">
                            {{ errors.max_amount_per_payment[0] }}
                        </div>
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Pago máximo por mes</label>
                        <money class="form-control" v-model="form.max_amount_per_month" disabled></money>


                        <div v-if="errors && errors.max_amount_per_month" class="text-danger">
                            {{ errors.max_amount_per_month[0] }}
                        </div>
                    </div>

                    <div v-if="errors && errors.rules" class="col-md-12 mt-3">
                        <div class="text-danger">
                            {{ errors.rules[0] }}
                        </div>
                    </div>

                    <div class="col-md-12">
                        <hr>

                        <button type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i>
                            Guardar
                        </button>

                        <button type="button" @click="closedModal()" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i>
                            Regresar
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>